import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';
import { controlDisabled, focusRing } from '../lib/control';

const choice = `size-6 min-h-6 min-w-6 shrink-0 cursor-pointer accent-primary ${focusRing} ${controlDisabled}`;

export type NativeCheckboxProps = Omit<ComponentProps<'input'>, 'type'>;
export type NativeRadioProps = Omit<ComponentProps<'input'>, 'type'>;

/**
 * `<input type="checkbox">` nativo com o visual do design system (DS-04). Use quando o campo é ligado a
 * `react-hook-form` por `register(...)` ou a estado controlado por `checked`/`onChange`; para o caso Radix
 * (`onCheckedChange`) use `Checkbox`. O rótulo vem de um `<label>` do chamador, que também é o alvo de toque:
 * a caixa mantém um alvo mínimo de 24 px mesmo em formulários compactos (WCAG 2.5.8).
 */
export function NativeCheckbox({ className, ...props }: NativeCheckboxProps) {
  return (
    <input
      data-slot="native-checkbox"
      type="checkbox"
      className={cn(choice, className)}
      {...props}
    />
  );
}

/** `<input type="radio">` nativo com o visual do design system; agrupe por `name` dentro de um `fieldset`/`legend`. */
export function NativeRadio({ className, ...props }: NativeRadioProps) {
  return (
    <input data-slot="native-radio" type="radio" className={cn(choice, className)} {...props} />
  );
}
